var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationBill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5008",
    x: 0,
    y: 0,
    width: 74,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6340",
    "data-name": "Group 6340",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_5008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5008-2",
    "data-name": "Rectangle 5008",
    transform: "translate(9 6)",
    fill: "#fefeff",
    stroke: "#cecece",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 55,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 54,
    rx: 17.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6331",
    "data-name": "Group 6331",
    transform: "translate(16 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.275,3.49A4.368,4.368,0,0,0,8.549,0H0A4.37,4.37,0,0,0,4.275,3.49Z",
    transform: "translate(7.359 24.432)",
    fill: "#03375f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M20.447,16.865c-.03,0-.059.005-.089.005A9.291,9.291,0,0,1,12.8,2.159V1.164a1.163,1.163,0,1,0-2.326,0V2.42a8.148,8.148,0,0,0-6.98,8.05v3.244A7.8,7.8,0,0,1,.712,19.686a2.036,2.036,0,0,0,1.325,3.583h19.2a2.036,2.036,0,0,0,1.314-3.592,7.783,7.783,0,0,1-2.1-2.813Z",
    fill: "#03375f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M2.822,16.864c.03,0,.059.005.089.005,5.132,0,7.562-3.778,7.562-8.909,0-2.016,1.094-4.277,0-5.8V1.164a1.163,1.163,0,1,1,2.326,0V2.42a8.148,8.148,0,0,1,6.981,8.05v3.244a7.8,7.8,0,0,0,2.778,5.972,2.036,2.036,0,0,1-1.325,3.583H2.037A2.036,2.036,0,0,1,.723,19.677a7.783,7.783,0,0,0,2.1-2.813Z",
    fill: "#03375f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBill);
export default __webpack_public_path__ + "static/media/notificationBill.f5c5504faf13f23daa731e9fea647c26.svg";
export { ForwardRef as ReactComponent };